import { useState, useEffect } from 'react';
import { getApiConnections } from '../../API/ProtectedAuth';
import { handleApiError } from '../../Utils/errorHandler';

export default function useApiConnections(queryParams = {}) {
  const [data, setData] = useState({ 
    connections: [], 
    total: 0, 
    page: 1, 
    pageSize: 20,
    next: null,
    previous: null,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchConnections = async () => {
      setLoading(true);
      setError(null);
      
      try {
        const { connections, total, next, previous } = await getApiConnections(queryParams);
        
        setData({
          connections,
          total,
          page: queryParams.page ?? 1,
          pageSize: queryParams.pageSize ?? 20,
          next,
          previous,
        });
      } catch (err) {
        const errorMessage = handleApiError(err);
        setError(errorMessage);
        console.error('❌ خطأ في جلب قائمة اتصالات API:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchConnections();
  }, [queryParams]);

  return { 
    connections: data.connections, 
    total: data.total, 
    page: data.page, 
    pageSize: data.pageSize,
    next: data.next,
    previous: data.previous,
    loading, 
    error,
    refetch: () => {
      const fetchConnections = async () => {
        setLoading(true);
        setError(null);
        
        try {
          const { connections, total, next, previous } = await getApiConnections(queryParams);
          
          setData({
            connections,
            total,
            page: queryParams.page ?? 1,
            pageSize: queryParams.pageSize ?? 20,
            next,
            previous,
          });
        } catch (err) {
          const errorMessage = handleApiError(err);
          setError(errorMessage);
          console.error('خطأ في إعادة جلب قائمة اتصالات API:', err);
        } finally {
          setLoading(false);
        }
      };
      
      fetchConnections();
    }
  };
}
